import { ReactNode } from 'react'

import { SidebarProvider } from '.'

export const Providers = ({ children }: { children: ReactNode }) => <SidebarProvider>{children}</SidebarProvider>
